import React from "react";
import LinkifyText from "./LinkifyText";

interface DescriptionTextProps {
	text: string;
}

const DescriptionText: React.SFC<DescriptionTextProps> = (props: any & DescriptionTextProps) => {
	//   const text = props.text.replace("\\n", "\n");
	if (!props.text) return null;
	const text = props.text.replace(/\\n/g, "\n");
	// .replace("\r", "\n")
	// .replace("\\r", "\n");
	return (
		<span style={props.style}>
			{(text || "").split("\n").reduce((arr, line: string, index) => {
				return arr.concat(
					<React.Fragment key={index}>
						<LinkifyText text={line} />
						{"\n"}
					</React.Fragment>
				);
			}, [])}
		</span>
	);
};

export default DescriptionText;
